import { render, staticRenderFns } from "./DataTablesGrid.vue?vue&type=template&id=c1da52e6"
import script from "./DataTablesGrid.vue?vue&type=script&lang=js"
export * from "./DataTablesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports